<template>
    <!-- <div class="print_template" :class="{data.templateSettings.theme, 'preview':preview}" full-width> -->
    <div>
        <div v-if="!$root.TransactionSettings.fullPagePrint" class="bill_template template_101 template_301 print_template" :class="{'preview':preview, 'print-settings':isEditable}" full-width>

        <table full-width>
            <thead class="primary-header noborder">

                <tr center-align>
                    <td colspan="4"><u>Bill of Materials</u></td>
                </tr>

                <!-- <tr right-align v-if="!data.status">
                    <td colspan="3" redcolor>Cancelled!</td>
                </tr> -->

                <tr style="border-bottom: 1px #ddd solid;">
                    <td colspan="4" class="business_row">

                        <div class="col67">
                            <div class="business_logo mr-2" v-ripple v-if="$root.CurrentBusiness.businessLogo">
                                <img :src="$root.CurrentBusiness.businessLogo"/>
                                <!-- <div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Logo</div> -->
                            </div>

                            <div class="business_details" style="display: grid;">
                                <!-- <div v-html="header.data.content" v-ripple v-if="header.data && header.data.content" :class="{'editable':isEditable}"></div>
                                <div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Business Details</div> -->
                                <div>{{ $root.CurrentBusiness.BusinessName }}</div>
                                <div>{{ $root.CurrentBusiness.Address }}</div>
                                <div>{{$root.CurrentBusiness.State}}</div>
                            </div>

                        </div>

                        <div class="col33" right-align>
                            <template>
                                <strong>No.</strong>: {{data.transactionDetails.transactionNumber}}<br>
                                <strong>Date</strong>: 
                                <template v-if="$root.TransactionSettings.invoiceDateFormat">
                                    {{ data.transactionDetails.transactionDate | moment($root.TransactionSettings.invoiceDateFormat) }}
                                </template>
                                <template v-else>
                                    {{ data.transactionDetails.transactionDate | moment("DD-MMM-YYYY") }}
                                </template>
                            </template>
                        </div>	
                    </td>
                </tr>

                <tr style="border-bottom: 1px #ddd solid;border-top: 1px #ddd solid;">
                    <td><strong>Item Name</strong></td>
                    <td><strong>Qty</strong></td>
                    <td><strong>Rate</strong></td>
                    <td><strong>Amount</strong></td>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td grey-back noborder colspan="4"><strong>Finished Good</strong></td>
                </tr>

                <template v-for="(item, index) in finishedGoods">
                    <tr :key="index" style="border-bottom: 1px #ddd solid;">
                        <td noborder>{{ item.cols.itemName }}</td>
                        <td noborder>{{ item.cols.qty }} {{ item.cols.unitName }}</td>
                        <td noborder>{{ item.cols.rate }}</td>
                        <td noborder>{{ roundUpto2Decimals(item.cols.netAmount) }}</td>
                    </tr>

                    <tr v-if="item.cols.productBatches && item.cols.productBatches.length" :key="'batches'+index">
                        <td colspan="4" noborder>
                            <template v-for="(batch, batchIndex) in item.cols.productBatches">
                                <v-card flat :key="batchIndex">
                                    <v-card-text>
                                        <v-layout class="batch_layout ma-0" row wrap>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.batchNumber">
                                                <div light-opacity-color>Batch No.</div>
                                                <div>{{ batch.batchNumber }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.batchSize">
                                                <div light-opacity-color>Size</div>
                                                <div>{{ batch.batchSize }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.batchMRP">
                                                <div light-opacity-color>MRP</div>
                                                <div>{{ batch.batchMRP }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.mfgDate">
                                                <div light-opacity-color>Mfg. Date</div>
                                                <div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.expDate">
                                                <div light-opacity-color>Exp. Date</div>
                                                <div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.field1">
                                                <div light-opacity-color>Serial Number</div>
                                                <div>{{ batch.field1 }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.field2">
                                                <div light-opacity-color>IMEI Number</div>
                                                <div>{{ batch.field2 }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.field3">
                                                <div light-opacity-color>Part Number</div>
                                                <div>{{ batch.field3 }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.field4">
                                                <div light-opacity-color>Model Number</div>
                                                <div>{{ batch.field4 }}</div>
                                            </v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="item.cols.productBatches.length>1">
                                                <div light-opacity-color>Quantity</div>
                                                <div>{{ batch.qty }}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                                <v-divider :key="'divider'+batchIndex" v-if="batchIndex != item.cols.productBatches.length - 1"></v-divider>
                            </template>
                        </td>
					</tr>
                </template>

                <tr>
                    <td grey-back noborder colspan="4"><strong>Materials</strong></td>
                </tr>
                <template v-for="(item, index) in trProducts">
                    <tr :key="index" style="border-bottom: 1px #ddd solid;">
                        <td noborder>{{ item.cols.itemName }}</td>
                        <td noborder>{{ item.cols.qty }} {{ item.cols.unitName }}</td>
                        <td noborder>{{ item.cols.rate }}</td>
                        <td noborder>{{ roundUpto2Decimals(item.cols.netAmount) }}</td>
                    </tr>

                    <tr v-if="item.cols.productBatches && item.cols.productBatches.length" :key="'batches'+index">
                        <td colspan="4" noborder>
                            <template v-for="(batch, batchIndex) in item.cols.productBatches">
                                <v-card flat :key="batchIndex">
                                    <v-card-text>
                                        <v-layout class="batch_layout ma-0" row wrap>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.batchNumber">
                                                <div light-opacity-color>Batch No.</div>
                                                <div>{{ batch.batchNumber }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.batchSize">
                                                <div light-opacity-color>Size</div>
                                                <div>{{ batch.batchSize }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.batchMRP">
                                                <div light-opacity-color>MRP</div>
                                                <div>{{ batch.batchMRP }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.mfgDate">
                                                <div light-opacity-color>Mfg. Date</div>
                                                <div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.expDate">
                                                <div light-opacity-color>Exp. Date</div>
                                                <div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.field1">
                                                <div light-opacity-color>Serial Number</div>
                                                <div>{{ batch.field1 }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.field2">
                                                <div light-opacity-color>IMEI Number</div>
                                                <div>{{ batch.field2 }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.field3">
                                                <div light-opacity-color>Part Number</div>
                                                <div>{{ batch.field3 }}</div>
                                            </v-flex>
                                            <v-flex xs3 sm3 md3 mb-2 v-if="batch.field4">
                                                <div light-opacity-color>Model Number</div>
                                                <div>{{ batch.field4 }}</div>
                                            </v-flex>
											<v-flex xs4 sm4 md4 mb-2 v-if="item.cols.productBatches.length>1">
                                                <div light-opacity-color>Quantity</div>
                                                <div>{{ batch.qty }}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                                <v-divider :key="'divider'+batchIndex" v-if="batchIndex != item.cols.productBatches.length - 1"></v-divider>
                            </template>
                        </td>
					</tr>
                </template>

                <template v-for="(item, index) in data.transactionDetails.transactionAddOns">
                    <tr :key="index">
                        <td noborder></td>
                        <td noborder></td>
                        <td noborder>{{ item.name }}</td>
                        <td noborder>{{ item.value }}</td>
                    </tr>
                </template>

                <tr style="border-bottom: 1px #ddd solid;" font-medium>
                    <td noborder></td>
                    <td noborder></td>
                    <td noborder>Total</td>
                    <td noborder>{{ data.transactionDetails.amount }}</td>
                </tr>

                <tr v-if="data.transactionDetails && data.transactionDetails.notes">
                    <td noborder colspan="4">
                        <div class="left-column nopadding">
                            <div v-if="data.transactionDetails.notes">
                                <strong>Note</strong><br>
                                {{data.transactionDetails.notes}}  
                            </div>
                        </div>
                    </td>
                </tr>
                
            </tbody>

        </table>

        <!-- <div class="page-footer mt-3">
            <div class="branding watermark">
                <div style="font-size:8px !important">Powered By</div>
                <div style="font-size:10px !important" class="title primary-color">
                    <img src="../../../assets/Final_BizOpsLogo.svg" class="brand_logo logo_small" alt="bizops_logo">
                    BizOps App
                </div>
            </div>
        </div> -->
        </div>

        <div v-else>
			
			<div class="bill_template template_101 template_302 page bom_template" :class="{'preview':preview, 'print-settings':isEditable}" full-width>
				<div class="content">
					<table full-width>
						<thead class="primary-header">

							<tr center-align>
								<td colspan="4">Bill of Materials</td>
							</tr>

							<!-- <tr right-align v-if="!data.status">
								<td colspan="3" redcolor>Cancelled!</td>
							</tr> -->

							<tr style="border-bottom: 1px #ddd solid;">
								<td colspan="4" class="business_row">

									<div class="col67">
										<div class="business_logo mr-2" v-ripple v-if="$root.CurrentBusiness.businessLogo">
											<img :src="$root.CurrentBusiness.businessLogo"/>
											<!-- <div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Logo</div> -->
										</div>

										<div class="business_details" style="display: grid;">
											<!-- <div v-html="header.data.content" v-ripple v-if="header.data && header.data.content" :class="{'editable':isEditable}"></div>
											<div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Business Details</div> -->
											<div>{{ $root.CurrentBusiness.BusinessName }}</div>
											<div>{{ $root.CurrentBusiness.Address }}</div>
											<div>{{$root.CurrentBusiness.State}}</div>
										</div>

									</div>

									<div class="col33" right-align>
										<template>
											<strong>No.</strong>: {{data.transactionDetails.transactionNumber}}<br>
											<strong>Date</strong>: 
                                            <template v-if="$root.TransactionSettings.invoiceDateFormat">
                                                {{ data.transactionDetails.transactionDate | moment($root.TransactionSettings.invoiceDateFormat) }}
                                            </template>
                                            <template v-else>
                                                {{ data.transactionDetails.transactionDate | moment("DD-MMM-YYYY") }}
                                            </template>
										</template>
									</div>	
								</td>
							</tr>

							<tr style="border-bottom: 1px #ddd solid;border-top: 1px #ddd solid;">
								<td><strong>Item Name</strong></td>
								<td><strong>Qty</strong></td>
								<td right-align><strong>Rate</strong></td>
								<td right-align><strong>Amount</strong></td>
							</tr>
						</thead>

						<tbody>
							<tr>
								<td grey-back colspan="4"><strong>Finished Good</strong></td>
							</tr>

							<template v-for="(item, index) in finishedGoods">
								<tr :key="index" style="border-bottom: 1px #ddd solid;">
									<td>{{ item.cols.itemName }}</td>
									<td>{{ item.cols.qty }} {{ item.cols.unitName }}</td>
									<td right-align>{{ item.cols.rate }}</td>
									<td right-align>{{ roundUpto2Decimals(item.cols.netAmount) }}</td>
								</tr>

								<tr v-if="item.cols.productBatches && item.cols.productBatches.length" :key="'batches'+index">
									<td colspan="4">
										<template v-for="(batch, batchIndex) in item.cols.productBatches">
											<v-card flat :key="batchIndex">
												<v-card-text>
													<v-layout class="batch_layout" row wrap>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.batchNumber">
															<div light-opacity-color>Batch No.</div>
															<div>{{ batch.batchNumber }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.batchSize">
															<div light-opacity-color>Size</div>
															<div>{{ batch.batchSize }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.batchMRP">
															<div light-opacity-color>MRP</div>
															<div>{{ batch.batchMRP }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.mfgDate">
															<div light-opacity-color>Mfg. Date</div>
															<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.expDate">
															<div light-opacity-color>Exp. Date</div>
															<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.field1">
															<div light-opacity-color>Serial Number</div>
															<div>{{ batch.field1 }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.field2">
															<div light-opacity-color>IMEI Number</div>
															<div>{{ batch.field2 }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.field3">
															<div light-opacity-color>Part Number</div>
															<div>{{ batch.field3 }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.field4">
															<div light-opacity-color>Model Number</div>
															<div>{{ batch.field4 }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="item.cols.productBatches.length>1">
															<div light-opacity-color>Quantity</div>
															<div>{{ batch.qty }}</div>
														</v-flex>
													</v-layout>
												</v-card-text>
											</v-card>
											<v-divider :key="'divider'+batchIndex" v-if="batchIndex != item.cols.productBatches.length - 1"></v-divider>
										</template>
									</td>
								</tr>
							</template>

							<tr>
								<td grey-back colspan="4"><strong>Materials</strong></td>
							</tr>
							<template v-for="(item, index) in trProducts">
								<tr :key="index" style="border-bottom: 1px #ddd solid;">
									<td>{{ item.cols.itemName }}</td>
									<td>{{ item.cols.qty }} {{ item.cols.unitName }}</td>
									<td right-align>{{ item.cols.rate }}</td>
									<td right-align>{{ roundUpto2Decimals(item.cols.netAmount) }}</td>
								</tr>

								<tr v-if="item.cols.productBatches && item.cols.productBatches.length" :key="'batches'+index">
									<td colspan="4">
										<template v-for="(batch, batchIndex) in item.cols.productBatches">
											<v-card flat :key="batchIndex">
												<v-card-text>
													<v-layout class="batch_layout" row wrap>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.batchNumber">
															<div light-opacity-color>Batch No.</div>
															<div>{{ batch.batchNumber }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.batchSize">
															<div light-opacity-color>Size</div>
															<div>{{ batch.batchSize }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.batchMRP">
															<div light-opacity-color>MRP</div>
															<div>{{ batch.batchMRP }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.mfgDate">
															<div light-opacity-color>Mfg. Date</div>
															<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.expDate">
															<div light-opacity-color>Exp. Date</div>
															<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.field1">
															<div light-opacity-color>Serial Number</div>
															<div>{{ batch.field1 }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.field2">
															<div light-opacity-color>IMEI Number</div>
															<div>{{ batch.field2 }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.field3">
															<div light-opacity-color>Part Number</div>
															<div>{{ batch.field3 }}</div>
														</v-flex>
														<v-flex xs3 sm3 md3 mb-2 v-if="batch.field4">
															<div light-opacity-color>Model Number</div>
															<div>{{ batch.field4 }}</div>
														</v-flex>
														<v-flex xs4 sm4 md4 mb-2 v-if="item.cols.productBatches.length>1">
															<div light-opacity-color>Quantity</div>
															<div>{{ batch.qty }}</div>
														</v-flex>
													</v-layout>
												</v-card-text>
											</v-card>
											<v-divider :key="'divider'+batchIndex" v-if="batchIndex != item.cols.productBatches.length - 1"></v-divider>
										</template>
									</td>
								</tr>
							</template>

							<template v-for="(item, index) in data.transactionDetails.transactionAddOns">
								<tr :key="index">
									<td></td>
									<td></td>
									<td>{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</template>

							<tr class="spacer-row">
								<td colspan="4"></td>
							</tr>

							<tr style="border-bottom: 1px #ddd solid;" font-medium>
								<td colspan="3">Total</td>
								<td right-align>&#8377; {{ data.transactionDetails.amount }}</td>
							</tr>

							<tr v-if="data.transactionDetails && data.transactionDetails.notes">
								<td colspan="4">
									<div class="left-column nopadding">
										<div v-if="data.transactionDetails.notes">
											<strong>Note</strong><br>
											{{data.transactionDetails.notes}}  
										</div>
									</div>
								</td>
							</tr>
							
						</tbody>

					</table>
				</div>
			</div>
		</div>
    </div>
</template>

<script>

const transactionTypes = require('../../../config.js').configs.transactionTypes;

    export default{
        props:['data', 'preview', 'isEditable', 'editBusiness', 'editLogo', 'editPrintField'],
        data(){
            return{
                headers:[{"name":"Particulars", "width":67}, {"name":"Amount", "width":33}],
                items:[],
                // header:null,
                // terms:null,
                // bankDetails:null,
                // signatory:null
                header:{data:null, fieldId:null, showInPrintOut:true},
                signatory:{data:null, fieldId:null, showInPrintOut:true},
                logoField:{data:null, fieldId:null, showInPrintOut:false},
                invoiceFieldsObj:{
                    "businessLogo": {"fieldId":"businessLogo", "sectionName":"Business Logo",  "status":true, "groupName":"businessFields", "defaultStatus":true},
                    "signatory": {"fieldId":"signatory", "sectionName":"signatory", "status":true, "groupName":"PrintField", "defaultStatus":true},
                },

                brandLogo:{showInPrintOut:true},
                finishedGoods:[],
                trProducts:[]
            }
        },
        methods:{
            fn_showSection: function(showInPrintOut){
                if(this.isEditable){
                    return true;
                }
                else{
                    if(showInPrintOut){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            },

            fn_toggleField: function(val, fieldId){
                // var self = this;
                let dataObj = {};
                dataObj.status = val;
                dataObj.fieldId = fieldId;
                this.postData('TogglePrintFieldVisibility', dataObj, 
                    {
                        onSuccess: function(response){
                              console.log(response);
                        },
                        onError: function(error){
                              console.log(error);
                        }
                    }
                );
            },

            fn_toggleBrandLogo: function(val, fromPreview){
                let dataObj = {};
                dataObj.LocalKey = 'bizopslogo_visibility';
                dataObj.LocalValue = val;
                this.$root.fn_saveLocalData(dataObj);

                fromPreview ? this.brandLogo.showInPrintOut = val : '';

                this.fn_getToken(val);
            },

            fn_getToken: function(val){
                if(this.$root.appVersion < 104){
                    return;
                }
                // this.showLoading("Please wait...");
                this.$root.fn_getAuthToken(token=>{
                    this.fn_brandLogoToServer(val, token);
                });
            },

            fn_brandLogoToServer: function(val, token){
                if(!navigator.onLine){
                    // this.showToast('Internet not available');
                    return;
                }
                
                // let self = this;
                let dataObj = {};
                dataObj.businessId = this.$root.CurrentBusiness.BusinessID;
                dataObj.token = token;

                let fnName = val ? "EnableLogo" : "RemoveLogo";
                this.getServerData(fnName, dataObj, 
                    {
                    onSuccess: function(response){
                        console.log(response);
                        // self.hideLoading();
                    }, 
                    onError: function(error){
                        console.log(error);
                        // self.hideLoading();
                        // if(typeof JSON.parse(error) == 'object'){
                        //   let response = JSON.parse(error);
                        //   self.showToast(response.Message);
                        // }
                    }, 
                    }
                );
            },

            fn_editPrintField(fieldId, type){
                this.editPrintField ? this.editPrintField(fieldId, type) : '';
            },

            fn_editParty(){
                this.editParty ? this.editParty() : '';
            },

            fn_editBusiness(){
                this.editBusiness ? this.editBusiness() : '';
            },

            fn_editLogo(){
                this.editLogo ? this.editLogo() : '';
            },

            fn_init: function(callback){
                
                // this.fn_sortItems();	
                // this.fn_processSections();

                this.finishedGoods = this.data.transactionDetails.transactionItems.filter(item=>{
                    return item.cols.finishedGoodProductId
                });

                this.trProducts = this.data.transactionDetails.transactionItems.filter(item=>{
                    return !item.cols.finishedGoodProductId
                });

                this.fn_processKeywords();

                // setTimeout(() => {
                // 	let signatureImageElement = document.querySelector(".bill_template .bottom-right-column .signatory img");
                // 	if(this.signatory.data && signatureImageElement){
                // 		let maxWidth = 120;
                // 		let maxHeight = 48;
                // 		let srcWidth = signatureImageElement.offsetWidth ? signatureImageElement.offsetWidth : signatureImageElement.width;
                // 		let srcHeight = signatureImageElement.offsetHeight ? signatureImageElement.offsetHeight : signatureImageElement.height;
                // 		let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

                // 		let imgWidth = srcWidth * ratio;
                // 		let imgHeight = srcHeight * ratio;

                // 		signatureImageElement.style.width = imgWidth + "px";
                // 		signatureImageElement.style.height = imgHeight + "px";
                // 	}
                // }, 500);

                this.$root.fn_getLocalData('bizopslogo_visibility', response=>{
                    let val = JSON.parse(response);
                    this.brandLogo.showInPrintOut = val === null ? true : val;
                })

                callback && typeof(callback) == 'function' ? callback() : '';
            
                if(this.$root.TransactionSettings.fullPagePrint){
                    let fullPageElement = document.querySelector('.page.bom_template');
                    let heightInMM = fullPageElement.offsetHeight * 0.264583; // convert px to mm
                    let padding = 50 //5 mm top 5 mm bottom
                    document.querySelectorAll('.page.bom_template.template_101 tr.spacer-row')[0].style.setProperty('height', (297 - heightInMM - padding) + 'mm', 'important');//.height = (297 - heightInMM - padding) + 'mm';
                    document.querySelectorAll('.page.bom_template.template_101 tr.spacer-row')[1].style.setProperty('height', (297 - heightInMM - padding) + 'mm', 'important');
                }
            },
            fn_sortItems: function(){
                this.data.transactionLedgers.sort(function(a, b){
                    return b.amountType - a.amountType;
                });
            },
            fn_processSections: function(){
                for(let i=0; i<this.data.templateSettings.printTemplateSections.length; i++){
                    let additionalData = this.data.templateSettings.printTemplateSections[i].addData;
                    if(this.data.templateSettings.printTemplateSections[i].sectionName == 'header'){
                        // this.header = JSON.parse(additionalData);
                        this.header.data = JSON.parse(additionalData);
                        this.header.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
                    }
                    else if(this.data.templateSettings.printTemplateSections[i].sectionName == 'signature'){
                        // if(additionalData){
                        // 	this.signatory.data = additionalData.indexOf("img") != -1 ?  JSON.parse(additionalData) : null;	
                        // }
                        // else{
                        // 	this.signatory.data = null;
                        // }
                        // this.signatory.data = additionalData.indexOf("img") != -1 ?  JSON.parse(additionalData) : null;
                        this.signatory.data = additionalData ?  JSON.parse(additionalData) : null;
                        this.signatory.fieldId = this.data.templateSettings.printTemplateSections[i].fieldId;
                        this.signatory.showInPrintOut = this.data.templateSettings.printTemplateSections[i].status;
                    }
                }

                if(this.data.templateSettings.printFieldLogo){
                    this.logoField.fieldId = this.data.templateSettings.printFieldLogo.fieldId;
                    this.logoField.showInPrintOut = this.data.templateSettings.printFieldLogo.status;
                }
            },
            fn_processKeywords: function(){
                this.fn_replaceKeywords(this.header.data);
                this.fn_replaceKeywords(this.signatory.data);
            },
            fn_replaceKeywords: function(category){
                if(category && category.content){
                    if(String.prototype.replaceAll){
                    category.content = category.content.replaceAll('{{BusinessName}}', this.$root.CurrentBusiness.BusinessName);
                    category.content = category.content.replaceAll('{{BusinessAddress}}', this.$root.CurrentBusiness.Address ? this.$root.CurrentBusiness.Address : '');
                    category.content = category.content.replaceAll('{{BusinessState}}', this.$root.CurrentBusiness.State ? this.$root.CurrentBusiness.State : '');
                    category.content = category.content.replaceAll('{{GSTIN}}', this.$root.CurrentBusiness.GSTNumber ? this.$root.CurrentBusiness.GSTNumber : '');

                    if(this.$root.CurrentBusiness.GSTRegistrationStatus == 3){
                        category.content = category.content.replaceAll(/GSTIN: /g, '');
                    }
                }
                else{
                    category.content = category.content.replace(new RegExp('{{BusinessName}}', 'g'), this.$root.CurrentBusiness.BusinessName);
                    category.content = category.content.replace(new RegExp('{{BusinessAddress}}', 'g'), this.$root.CurrentBusiness.Address ? this.$root.CurrentBusiness.Address : '');
                    category.content = category.content.replace(new RegExp('{{BusinessState}}', 'g'), this.$root.CurrentBusiness.State ? this.$root.CurrentBusiness.State : '');
                    category.content = category.content.replace(new RegExp('{{GSTIN}}', 'g'), this.$root.CurrentBusiness.GSTNumber ? this.$root.CurrentBusiness.GSTNumber : '');

                    if(this.$root.CurrentBusiness.GSTRegistrationStatus == 3){
                        category.content = category.content.replace(new RegExp('GSTIN: ', 'g'), '');
                    }
                }
                    // category.content = category.content.replaceAll('{{BusinessName}}', this.$root.CurrentBusiness.BusinessName);
                    // category.content = category.content.replaceAll('{{BusinessAddress}}', this.$root.CurrentBusiness.Address ? this.$root.CurrentBusiness.Address : '');
                    // category.content = category.content.replaceAll('{{BusinessState}}', this.$root.CurrentBusiness.State);
                    // category.content = category.content.replaceAll('{{GSTIN}}', this.$root.CurrentBusiness.GSTNumber ? this.$root.CurrentBusiness.GSTNumber : '');

                    // if(this.$root.CurrentBusiness.GSTRegistrationStatus == 3){
                    // 	category.content = category.content.replaceAll(/GSTIN: /g, '');
                    // }
                }
            },
            // convertNumberToWords: function(amount) {
            //     // custom addon for paise
            //     let paise = null;
            //     let stramount = amount.toString();
            //     if(stramount.indexOf('.')!=-1){
            //       paise = stramount.substring(stramount.indexOf('.') + 1);  
            //     }
            //     // end of custom addon

            //     var words = new Array();
            //     words[0] = '';
            //     words[1] = 'One';
            //     words[2] = 'Two';
            //     words[3] = 'Three';
            //     words[4] = 'Four';
            //     words[5] = 'Five';
            //     words[6] = 'Six';
            //     words[7] = 'Seven';
            //     words[8] = 'Eight';
            //     words[9] = 'Nine';
            //     words[10] = 'Ten';
            //     words[11] = 'Eleven';
            //     words[12] = 'Twelve';
            //     words[13] = 'Thirteen';
            //     words[14] = 'Fourteen';
            //     words[15] = 'Fifteen';
            //     words[16] = 'Sixteen';
            //     words[17] = 'Seventeen';
            //     words[18] = 'Eighteen';
            //     words[19] = 'Nineteen';
            //     words[20] = 'Twenty';
            //     words[30] = 'Thirty';
            //     words[40] = 'Forty';
            //     words[50] = 'Fifty';
            //     words[60] = 'Sixty';
            //     words[70] = 'Seventy';
            //     words[80] = 'Eighty';
            //     words[90] = 'Ninety';
            //     amount = amount.toString();
            //     var atemp = amount.split(".");
            //     var number = atemp[0].split(",").join("");
            //     var n_length = number.length;
            //     var words_string = "";
            //     if (n_length <= 9) {
            //         var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
            //         var received_n_array = new Array();
            //         for (var i = 0; i < n_length; i++) {
            //             received_n_array[i] = number.substr(i, 1);
            //         }
            //         for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
            //             n_array[i] = received_n_array[j];
            //         }
            //         for (var i = 0, j = 1; i < 9; i++, j++) {
            //             if (i == 0 || i == 2 || i == 4 || i == 7) {
            //                 if (n_array[i] == 1) {
            //                     n_array[j] = 10 + parseInt(n_array[j]);
            //                     n_array[i] = 0;
            //                 }
            //             }
            //         }
            //         var value = "";
            //         for (var i = 0; i < 9; i++) {
            //             if (i == 0 || i == 2 || i == 4 || i == 7) {
            //                 value = n_array[i] * 10;
            //             } else {
            //                 value = n_array[i];
            //             }
            //             if (value != 0) {
            //                 words_string += words[value] + " ";
            //             }
            //             if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
            //                 words_string += "Crores ";
            //             }
            //             if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
            //                 words_string += "Lakhs ";
            //             }
            //             if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
            //                 words_string += "Thousand ";
            //             }
            //             if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
            //                 words_string += "Hundred and ";
            //             } else if (i == 6 && value != 0) {
            //                 words_string += "Hundred ";
            //             }
            //         }
            //         words_string = words_string.split("  ").join(" ");
            //     }

            //     if(!paise){
            //         return words_string;  
            //     }
            //     else{
            //         if(paise.length==1){
            //           paise = paise + "0";
            //         }
                    
            //         if(words_string){
            //           return words_string + 'Rupees and ' + this.convertNumberToWords(paise) + 'Paise';  
            //         }
            //         else{
            //           return '';
            //         }
            //     }
                
            // },

            fn_getPrefix: function(transactionListId){

                if(
                    (this.data.transactionListId == transactionTypes.receipt.id && 
                    (transactionListId == transactionTypes.salesInvoice.id || transactionListId == transactionTypes.purchaseReturn.id)) || 
                    (this.data.transactionListId == transactionTypes.payment.id && 
                    (transactionListId == transactionTypes.purchaseInvoice.id || transactionListId == transactionTypes.salesReturn.id))
                ){
                    return 'plus';
                }
                else if(
                    (this.data.transactionListId == transactionTypes.receipt.id && 
                    (transactionListId == transactionTypes.salesReturn.id || transactionListId == transactionTypes.purchaseInvoice.id)) || 
                    (this.data.transactionListId == transactionTypes.payment.id && 
                    (transactionListId == transactionTypes.salesInvoice.id || transactionListId == transactionTypes.purchaseReturn.id))
                ){
                    return 'minus';
                }

            },

            fn_previousBalance: function(){
                if(!this.data.partyDetails[0].currentBalance){
                    return 0;
                }

                if(this.data.transactionListId == '30001'){
                    return this.data.partyDetails[0].currentBalance + this.data.roundedAmount;
                }
                else if(this.data.transactionListId == '30002'){
                    return this.data.partyDetails[0].currentBalance - this.data.roundedAmount;
                }
            },
        }
    }
</script>

<style>
    /* ---------------- Primary Header Css -----------------*/

    .template_302 .business_logo{
        float: left;
    }
    /* .template_101.preview .business_details{
        padding-left: 56px;
    }
    .template_101.print-settings .business_details{
        margin-left: 56px;
        padding:0 !important;
    } */
    /* .template_101 .hasLogo .business_details{
        margin-left: 80px;
    } */
     .page.template_302 {
	width: 100%;
	/* height: 297mm; */
	/* padding: 5mm; */
	height: 100%;
	box-sizing: border-box;
	font-size: 12px;
	overflow: auto;
	}

	.page.template_302 .content {
	display: flex;
	flex-direction: column;
	height: 100%;
	}

	/* Table should grow */
	.page.template_302 .table-wrapper {
	flex: 1;
	display: flex;
	}

	/* Table full height */
	.page.template_302 table {
	/* width: 100%; */
	border-collapse: collapse;
	/* height: 100%; */
	}

	/* Make tbody stretch */
	/* .page.template_302 table tbody {
	height: 100%;
	} */

	/* KEY TRICK: spacer row expands */
	.page.template_302.bom_template .spacer-row {
	/* height: 100% !important; */
	vertical-align: bottom;
	}

	.page.template_302 .header-content{
		border: 1px solid #000;
		border-bottom: none;
	}

	.page.template_302 table th tr td,
	.page.template_302 table tr td {
	border: 1px solid #000 !important;
	padding: 8px;
	}

	.page.template_302 .right {
	text-align: right;
	}

	.page.template_302 p{
		margin-bottom: 0 !important;
	}

	.page.template_302 .receipt-footer{
		border: 1px solid #000;
		border-top: none;
		padding: 8px;
	}
</style>